const Listar = () => import('@/domains/notas_fiscais/auxiliares/tributacoes/views/Listar')
const Adicionar = () => import('@/domains/notas_fiscais/auxiliares/tributacoes/views/Adicionar')
const Editar = () => import('@/domains/notas_fiscais/auxiliares/tributacoes/views/Editar')
const Visualizar = () => import('@/domains/notas_fiscais/auxiliares/tributacoes/views/Visualizar')

const routes = [
    {
        name: 'listarGruposTributacoesEmissor',
        path: '/emissor/tributacoes',
        alias: ['/emissor/tributacoes/index'],
        component: Listar
    },
    {
        name: 'visualizarGrupoTributacaoEmissor',        
        path: '/emissor/tributacoes/visualizar/:id',
        component: Visualizar
    },
    {
        name: 'adicionarGrupoTributacaoEmissor', 
        path: '/emissor/tributacoes/adicionar',
        component: Adicionar
    },
    {
        name: 'editarGrupoTributacaoEmissor',      
        path: '/emissor/tributacoes/editar/:id',
        component: Editar
    }
]

export default routes
